import { createPinia } from "pinia";
import App from "./App.ce.vue";
import { i18n } from "./i18n";

export const setup = () => {
  return Object.freeze({
    component: App,
    plugins: [createPinia(), i18n],
  });
};
